const message = {
  INVALID_START_DATE_EMPTY: 'Start date cannot be empty.',
  INVALID_START_DATE_PAST: 'Start date cannot be in the past.',
  DIGITAL_SIGNATURE_REQUIRED_EMPTY: 'Digital signature required cannot be empty.',
};

export { message };
